module.exports = "<div class=\"hidden-print hidden-xs hidden-sm\">\n    <nav class=\"bs-docs-sidebar\" :class=\"{affix:affixed}\" :style=\"{marginTop:top}\">\n      <slot></slot>\n    </nav>\n  </div>";


//////////////////
// WEBPACK FOOTER
// ./~/.1.2.4@vue-html-loader!./~/.7.1.7@vue-loader/lib/selector.js?type=template&index=0!./src/Affix.vue
// module id = 96
// module chunks = 0


// WEBPACK FOOTER //
// webpack:///src/Affix.vue?0129